// Function to show the modal
function showBlock(modalId) {
  modalDisplay('block');
  document.getElementById("blockiPhone").style.display = 'none';
  document.getElementById("blockSamsung").style.display = 'none';
  document.getElementById(modalId).style.display = 'block';
}

// Function to hide the modal
function modalDisplay(value){
  document.getElementById('modal-device').style.display = value;
}
// Add event listener for iPhone button
document.querySelector(".button.button--primary.hero_iphone").addEventListener("click", function(e) {
  e.preventDefault();
  showBlock('blockiPhone');
});

// Add event listener for Samsung button
document.querySelector(".button.button--primary.hero_samsung").addEventListener("click", function(e) {
  e.preventDefault();
  showBlock('blockSamsung');
});



// Add event listener for close buttons
document.getElementById("modal-device-close").addEventListener("click", function(e) {
  e.preventDefault();
  console.log("close button clicked");
  modalDisplay('none');
});

// modalDisplay('none'); when click outside the modal class name "content_model_hero"
document.getElementById("modal-device").addEventListener("click", function(e) {
  if(e.target.className == "model_hero"){
    e.preventDefault();
    modalDisplay('none');
  }
});